<template>
	<tr class="hover:bg-gray-300 cursor-pointer text-left" @click="redirectToTarget">
		<td class="px-6 py-4">
			{{ text_template.name }}
		</td>
		<td class="px-6 py-4 text-right">
			<font-awesome-icon :icon="['fas', 'chevron-right']" class="cursor-pointer" />
		</td>
	</tr>
</template>

<script>
export default {
	name: 'TextTemplateRow',
	props: {
		text_template: { required: true },
	},
	methods: {
		redirectToTarget() {
			this.$router.push({
				name: 'text_templates.edit',
				params: { id: this.text_template.id },
			});
		},
	},
};
</script>

<style scoped></style>
